import { useCallback, useEffect } from 'react';
import { Field, useField } from 'formik';

import styled from 'styled-components';
import { Alert, Button, MenuItem, Typography } from '@mui/material';

import { FormRowsDivider, InputField } from '../../../fields';
import { api } from '../../../../api';
import { ApiError } from '../../../errors';
import { SendTestLead } from '../../send-test-lead';

export type GetResponseSettings = {
  apiKey: string;
  listId: string;
};

export const GetResponseIntegration = () => {
  const [{ value: getResponseIntegration }] = useField<GetResponseSettings>('campaign.getResponseIntegration');
  const [{ value: campaignId }] = useField('campaign.id');
  const [getLists, lists] = api.useLazyGetGetResponseListsQuery();

  const { apiKey, listId } = getResponseIntegration || {};

  const fetchLists = useCallback(async () => {
    if (!apiKey) {
      return;
    }

    await getLists({ apiKey });
  }, [apiKey, getLists]);

  useEffect(() => {
    fetchLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper>
      <FormRowsDivider />

      <Typography sx={{ fontWeight: 'bold', marginBottom: '12px' }}>GetResponse</Typography>

      <Alert severity="info" variant="filled" sx={{ marginBottom: '24px' }}>
        Чтобы отправлять заявки в GetResponse, вам нужно сгенерировать ключ API в настройках GetResponse
        <br />
        <Button href="https://app.getresponse.com/api" target="_blank" sx={{ marginLeft: '-8px' }}>
          Перейти в настройки
        </Button>
      </Alert>

      <Field
        name="campaign.getResponseIntegration.apiKey"
        component={InputField}
        label="Ключ API"
        className="form-field"
        type="password"
        onBlur={fetchLists}
      />

      <Field
        name="campaign.getResponseIntegration.listId"
        component={InputField}
        label="Список рассылки"
        className="form-field"
        disabled={lists.isLoading}
        select
      >
        {lists.data?.lists.map((list) => (
          <MenuItem key={list.campaignId} value={list.campaignId}>
            {list.name}
          </MenuItem>
        ))}
      </Field>

      {lists.isError && <ApiError error={lists.error} withMargin />}
      {listId && <SendTestLead integrationId="get-response" campaignId={campaignId} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .form-field {
    margin-bottom: 12px;
    width: 335px;
  }
`;
